import { createSelector } from 'reselect';

import { PROJECTION } from 'constants/ApiConstants';
import type { Page } from 'modules/global/generic.types';
import type { GenericSelectSlice } from 'modules/global/reducers/generic.selectSlice';
import { KioskStatus } from 'modules/kiosks/constants';
import type { KiosksGetRequestParams } from 'modules/kiosks/types';
import { getSelectedDealerId } from 'selectors/dealerSelectors';
import { getProps, getRoot } from 'utils/selectors';

import { getUIState as getBaseState, getKiosksByIds } from '.';

const getState = createSelector(getBaseState, ui => ui.selects);

const getSelectState = createSelector(
  getState,
  getProps<string>,
  (state, id): Partial<GenericSelectSlice> => state[id] ?? {}
);

const getSelectIds = createSelector(getSelectState, ({ ids }) => ids ?? []);

const getSelectPage = createSelector(getSelectState, ({ page }): Partial<Page> => page ?? {});

export const getSelectPageNumber = createSelector(getSelectPage, ({ number }) => number);

export const isSelectLoading = createSelector(getSelectState, ({ loading }) => loading);

export const hasMoreSelect = createSelector(getSelectState, ({ hasMore }) => hasMore);

const getSelectKiosks = createSelector(getRoot, getSelectIds, getKiosksByIds);

export const getFormattedSelectKiosks = createSelector(getSelectKiosks, kiosks =>
  kiosks.map(({ id, name }) => ({ value: id, label: name })));

export const getBaseRequestParams = createSelector(
  getSelectPage,
  getSelectedDealerId,
  ({ size, number }, dealerId): KiosksGetRequestParams => ({
    status: [KioskStatus.ACTIVE],
    size: size ?? 10,
    page: number ?? 0,
    projection: PROJECTION.SLICE,
    dealerIds: dealerId ? [dealerId] : [],
  })
);
